import React from "react";
import {formatLastName} from "../constants";

// ids (optional) mirrors p1/p2 positionally - ids[0] is p1's participant id,
// ids[1] is p2's. Passing it together with onPlayerClick makes that player's
// name open their profile (see TournamentScheduleMatchesModal's own caller);
// omitted by every other caller, so their names stay plain text as before.
export const renderParticipantRow = (p1, p2, m, idx, grade, t, br=true, ids=null, onPlayerClick=null, onTeamClick=null) => {
    const clickProps = (id) => (onPlayerClick && id) ? {
        onClick: (e) => { e.stopPropagation(); onPlayerClick(id); },
        style: { cursor: "pointer" }
    } : {};
    if (p1 || p2) {
        if (grade === 1) {
            const p = p1 || p2;
            if (typeof p === "string") return <span className="uppercase0">{p}</span>;
            const id = ids?.[0] || ids?.[1];

            return (
                <div className="player black-name" {...clickProps(id)}>
                    {p?.first_name && <span className="player-name-initial">{p.first_name[0]}. </span>}
                    <span className="uppercase0">{p.last_name ? formatLastName(p.last_name) : ""}</span>
                    {br ? < br /> : " "}
                </div>
            );
        }
        if (grade === 2) {
            const fmtD = (pObj, id) => {
                if (!pObj) return null;
                if (typeof pObj === "string") return <span className="uppercase0">{formatLastName(pObj)}</span>;
                const initial = pObj.first_name ? `${pObj.first_name.charAt(0).toUpperCase()}.` : "";
                return (
                    <span className="player black-name" {...clickProps(id)}>
                        {initial && <span className="player-name-initial">{initial} </span>}
                        <span className="uppercase0">{pObj.last_name ? formatLastName(pObj.last_name) : ""}</span>
                    </span>
                );
            };
            return (
                <>
                    {fmtD(p1, ids?.[0])}
                    {p1 && p2 && <>{br ? < br /> : " / "}</>}
                    {fmtD(p2, ids?.[1])}
                </>
            );
        }
        if (grade === 3) {
            const p = p1 || p2;
            const isString = typeof p === "string";
            const teamName = isString ? p : p.name;
            const label = isString ? formatLastName(p) : (p.name || `${t("Team")} ${p.number || ""}`);
            const teamClickProps = (onTeamClick && teamName) ? {
                onClick: (e) => { e.stopPropagation(); onTeamClick(teamName); },
                style: { cursor: "pointer" }
            } : {};
            return <span className={isString ? "uppercase0 black-name" : "black-name"} {...teamClickProps}>{label}</span>;
        }
    }


    if (m.group_number) {
        let pId = "", order = 1;

        outer:
            for (let i = 1; i <= (m.total || 0); i++) {
                for (let j = i + 1; j <= m.total; j++, order++) {
                    if (order === m.match_order) {
                        pId = idx === 0 ? i : j;
                        break outer;
                    }
                }
            }

        const char = String.fromCharCode(64 + m.group_number);
        return <span className="black-name">{t("Participant")} {m.total ? `${char}${pId}` : ""}</span>;
    }

    if ((m.x1 && idx === 0) || (m.x2 && idx === 1)) {
        return <span className="uppercase0">{t("Bye")}</span>;
    }

    const src = idx === 1 ? m.source_match_2 : m.source_match_1;
    return src ? (
        <span>
        {m.is_source_winner ? t("Winner") : t("Loser")} #{src}
    </span>
    ) : (
        <span className="black-name">
        {t("Participant")} {(m.match_number || m.match || 0) * 2 + idx - 1}
    </span>
    );
};